import React from 'react';
import useCan from '@shared/permissions/useCan';
import InventoryHoldShow from '@components/shared/inventory/InventoryHoldShow';
import { inventoryHoldService } from '@services/admin/inventoryHoldService';

export default function InventoryHoldShowPage() {
  const can = useCan();

  return (
    <InventoryHoldShow
      service={inventoryHoldService}
      role="admin"
      canRelease={can('inventories:write')}
    />
  );
}
